import { IonCardHeader, IonCardSubtitle, IonCardTitle } from "@ionic/react";
import ProgressBar from "../../../../../ProgressBar/ProgressBar";
import styles from "./MultiPopPopupProductionOrderSelectionSubscreen.module.scss";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import useHxfTranslation from "../../../../../../../barrel/hooks/useHxfTranslation";
import PrecisionManufacturing from "@mui/icons-material/PrecisionManufacturing";
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import { useState } from "react";
import useFeedbackService from "../../../../../../../barrel/hooks/useFeedbackService";
import ScanBarcodePopup from "../../../../../../FeaturePages/ProductionOrders/Standard/ScanBarcodePopup/ScanBarcodePopup";
import MobileWrapperCommunicationService from "../../../../../../../barrel/services/mobileWrapperCommunicationService";
import ScannablesService from "../../../../../../../barrel/services/ScannablesService";
interface IPropsSubSel {
  selectionData: any;
  onProductionOrderSelect: any;
  onGoBack: any;
}
function MultiPopPopupProductionOrderSelectionSubscreen(props: IPropsSubSel) {
  const {t} = useHxfTranslation();
  const [showBarcodeScannerPopup,setShowBarcodeScannerPopup] = useState(false);
  const feedbackService = useFeedbackService();

  const isPoAutoScannerEnabled = () => {
    return props?.selectionData?.autoSelScannerSettings?.allowedScanFormats &&  props?.selectionData?.autoSelScannerSettings?.allowedScanFormats?.length > 0;
  }
  const getProductionOrderElement = (obj: any, index: number) => {
    return (
      <IonCardHeader
        className={`${styles.elemElement}`}
        onClick={() => {
          props.onProductionOrderSelect(obj.Id_ProductionOrder);
        }}
      >
        <div className={styles.elemBackgroundContainer}>
        <PrecisionManufacturing />
        </div>
        <IonCardTitle className={styles.elemElementDescription}>
          {obj.name}
        </IonCardTitle>
        <IonCardSubtitle>
          <div className={styles.elemElementTitle}>{obj.code}</div>
        </IonCardSubtitle>
        <ProgressBar pgValue={obj.productionOrder_completePct} />
      </IonCardHeader>
    );
  };

  if (!props?.selectionData?.productionOrdersData) {
    return <></>;
  }

  return (
    <>

{isPoAutoScannerEnabled() && (
        <ScanBarcodePopup
        ghostMode={!showBarcodeScannerPopup}
        freeScannerMode={true}
          title="Scanner"
          visible={true}
          barcodeScannerSettings={props?.selectionData?.autoSelScannerSettings}
          onClosedCamera={() => {
            if (
              MobileWrapperCommunicationService().isDeviceMobileWrapper() &&
              props?.selectionData?.autoSelScannerSettings.useCamera &&
              !props?.selectionData?.autoSelScannerSettings.useExternalDevice
            ) {
              setShowBarcodeScannerPopup(false);
            }
          }}
          onInvalidScan={() => {
            feedbackService.notifyToast(t('invalid.code.scanned'),"warning");
          }}
          onFinishedScan={(result: any) => {
            console.log("RESULT: ", result);
         
            let format = result.resultFormat;
            let resultScan = result.resultScan;
            let delimiter = null;

            if (format.type === "barcode39") {
              delimiter = ScannablesService().hxfBarcode39Delimiter;
            }
            if (format.type === "barcode128") {
              delimiter = ScannablesService().hxfBarcode128Delimiter;
            }

            if (format.type === "qrcode") {
              delimiter = ScannablesService().hxfQrcodeDelimiter;
            }
            let pattern = format.pattern;
            let splittedPattern = pattern.split(delimiter);

            let indexThatIdentifiesTheProductionOrder = -1;
            for (let i = 0; i < splittedPattern.length; i++) {
              if (splittedPattern[i] === "[productionorder.id]") {
                indexThatIdentifiesTheProductionOrder = i;
                break;
              }
            }

            let indexThatIdentifiesTheProductionOrderProductId = -1;
            for (let i = 0; i < splittedPattern.length; i++) {
              if (splittedPattern[i] === "[productionorder.poproduct.id]") {
                indexThatIdentifiesTheProductionOrderProductId = i;
                break;
              }
            }

            if (indexThatIdentifiesTheProductionOrder !== -1) {
            
              let splittedResult = resultScan.split(delimiter);
              if (splittedResult.length !== splittedPattern.length) {
             
                console.log("Scan does not match the pattern");
                feedbackService.notifyToast(t('invalid.code.scanned'),"warning");
              } else {
             
                let productionOrderIdentifiableValue =
                  splittedResult[indexThatIdentifiesTheProductionOrder];
                console.log(
                  "Now redir to po with id val",
                  productionOrderIdentifiableValue
                );
                

                if (indexThatIdentifiesTheProductionOrderProductId !== -1) {
                  if (
                    splittedResult[
                      indexThatIdentifiesTheProductionOrderProductId
                    ]
                  ) {
                   /* redirLinkBuilder =
                      redirLinkBuilder +
                      "/po-product/" +
                      splittedResult[
                        indexThatIdentifiesTheProductionOrderProductId
                      ];*/
                  }
                }

                //props.history.push(redirLinkBuilder);
                props.onProductionOrderSelect(productionOrderIdentifiableValue);
              }
            }else{
              feedbackService.notifyToast(t('invalid.code.scanned'),"warning");
            }
          }}
          onClosePopup={() => {
            setShowBarcodeScannerPopup(false);
          }}
        />
      )}
      <div className={styles.selectedOperationInfo}>
        <div>{t('operation')}: {props.selectionData.operationCode}</div>
      </div>
      <div className={styles.content}>
        <div className={styles.contentTitle}>{t('select.a.productionorder')}:</div>
        <div className={styles.operationsContainer}>
          {/*<CustomElementGoBack onClick={() => {
                                        props.onGoBack();
                                    }}/> 
                                    <div className={styles.spaceArrow}></div>*/}

          {isPoAutoScannerEnabled() && (
                <div
        
                className={`${styles.activeProductionElement}  `}
              ><IonCardHeader
                className={`${styles.elemElement} ${styles.elemScanner}`}
                onClick={() => {
                  setShowBarcodeScannerPopup(true);
                }}
              >
                <div className={styles.scannerBgContainer}>
                <QrCodeScannerIcon fontSize="large" />
                </div>

                <div className={styles.scannerLabel}>{t('scanner')}</div>
              </IonCardHeader></div>
          )}


          {props.selectionData.productionOrdersData.map(
            (row: any, index: number) => (
              <div
                key={"multiOperation_po_" + index}
                className={`${styles.activeProductionElement}  `}
              >
                {getProductionOrderElement(row, index)}
              </div>
            )
          )}
        </div>
      </div>
    </>
  );
}

export default MultiPopPopupProductionOrderSelectionSubscreen;
